import type { ReportComponent } from '@/pages/reports/schemas';

export function normalizeHeroFirst(components: ReportComponent[]): ReportComponent[] {
  if (!components || components.length === 0) {
    return components;
  }

  const heroes = components.filter((c) => c.type === 'hero');
  if (heroes.length === 0) {
    return components;
  }

  const hero = heroes[0];
  const others = components.filter((c) => c.type !== 'hero');

  return [hero, ...others];
}
